import { DataBean } from "../DataBean";

export class ActaComiteItem extends DataBean {
  public async getActaComiteItemCatalogPorPropiedades(
    properties: any,
    maxRows: number
  ): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "java.util.List_getActaComiteItemCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async updateActaComiteItem(bean: any): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "com.credit.bean.ActaComiteItem_updateActaComiteItem_com.credit.bean.ActaComiteItem",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.credit.bean.ActaComiteItem",
        },
      ]
    );
  }
  public async getActaComiteItems(page: any, rows: any, props: any): Promise<any> {
    return this.getCustomService("CreditCore", "com.advantage.shared.Report_getActaComiteItems_Number_Number_java.util.Map", [page, rows, props]);
  }
  public async registerCreditActaItem(idActaComiteItem:number,fechaDesembolso:any,idEmployee:number): Promise<any> {
    return this.getCustomService("CreditCore", "java.util.List_registerCreditActaItem_Number_java.util.Date_Number", [idActaComiteItem,fechaDesembolso,idEmployee]);
  }
  public async registerCreditActa(idActaComite:number,fechaDesembolso:any,idEmployee:number): Promise<any> {
    return this.getCustomService("CreditCore", "java.util.List_registerCreditActa_Number_java.util.Date_Number", [idActaComite,fechaDesembolso,idEmployee]);
  }
}
